import React from "react"
import {useTranslation} from "react-i18next";

interface props {
    maxAge?:   number | null
    seconds:   number | null
    useColor?: boolean
}
const TimeDiffHuman: React.FC<props> = ( {maxAge = null, seconds, useColor = false} ) => {

    const { t } = useTranslation()

    let color = 'green'
    let result = ''

    if (seconds !== null) {
        if (seconds >= 365 * 86400) {
            let years = Math.floor(seconds / (365 * 86400))
            result += years + ' '
                + (years > 1 ? t('common.date_time.years') : t('common.date_time.year'))
        } else if (seconds >= 30 * 86400) {
            let months = Math.floor(seconds / (30 * 86400))
            result += months + ' '
                + (months > 1 ? t('common.date_time.months') : t('common.date_time.month'))
        } else if (seconds >= 86400) {
            let days = Math.floor(seconds / 86400)
            result += days + ' '
                + (days > 1 ? t('common.date_time.days') : t('common.date_time.day'))
        } else if (seconds >= 3600) {
            let hours = Math.floor(seconds / 3600)
            result += hours + ' '
                + (hours > 1 ? t('common.date_time.hours') : t('common.date_time.hour'))
        } else if (seconds >= 60) {
            let minutes = Math.floor(seconds / 60)
            result += minutes + ' '
                + (minutes > 1 ? t('common.date_time.minutes') : t('common.date_time.minute'))
        } else if (seconds > 0) {
            result += seconds + ' '
                + (seconds > 1 ? t('common.date_time.seconds') : t('common.date_time.second'))
        } else if (seconds === 0) {
            result += t('common.date_time.just_now')
        }
    }

    if (maxAge !== null && seconds !== null && seconds > maxAge) {
        color = 'orange'
    }

    if (maxAge && useColor) {
        return <span style={{ 'color': color }}>{result}</span>
    }

    return <span>{result}</span>
}

export default TimeDiffHuman